// Mağaza/İşletme statüsünde başvurunun bağlanacağı mağaza (yetkilisi olmayan açık mağazalar)
import { useEffect, useState } from 'react';
import axios from 'axios';
import { Search, Store, Check } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const StorePicker = ({ value, onChange, error, disabled }) => {
  const [items, setItems] = useState(null);
  const [q, setQ] = useState('');
  useEffect(() => { axios.get(`${API}/registration/available-stores`).then(r => setItems(r.data)).catch(() => setItems([])); }, []);
  const term = q.trim().toLocaleLowerCase('tr');
  const list = (items || []).filter(s => !term || `${s.name} ${s.floor || ''} ${s.location_name}`.toLocaleLowerCase('tr').includes(term));
  const sel = (items || []).find(s => s.id === value);
  return (
    <div className="space-y-2 pt-2" data-testid="review-store-picker">
      <p className={`text-sm font-medium ${error ? 'text-rose-600' : 'text-slate-700'}`}>Hangi mağaza? <span className="text-rose-600">*</span></p>
      {sel && <p className="flex items-center gap-1.5 text-xs font-semibold text-emerald-700" data-testid="review-store-selected"><Check className="h-3.5 w-3.5" />Seçilen: {sel.name}{sel.floor ? ` · ${sel.floor}` : ''} · {sel.location_name}</p>}
      {!disabled && (
        <div className={`rounded-md border ${error ? 'border-2 border-rose-500 ring-2 ring-rose-200' : ''}`}>
          <div className="relative border-b">
            <Search className="pointer-events-none absolute left-2.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-slate-400" />
            <input value={q} onChange={e => setQ(e.target.value)} placeholder="Mağaza ara..." className="h-9 w-full bg-transparent pl-8 pr-2 text-sm outline-none" data-testid="review-store-search" />
          </div>
          <div className="max-h-48 overflow-y-auto p-1" data-testid="review-store-list">
            {items === null ? <p className="p-3 text-xs text-slate-400">Yükleniyor...</p>
              : !list.length ? <p className="p-3 text-xs text-slate-400">Yetkilisi olmayan açık mağaza bulunamadı</p>
              : list.map(s => (
                <button key={s.id} type="button" onClick={() => onChange(s.id)} data-testid={`review-store-option-${s.id}`}
                  className={`flex w-full items-center gap-2 rounded px-2 py-1.5 text-left text-sm transition-colors ${value === s.id ? 'bg-sky-100 text-sky-900' : 'hover:bg-slate-100'}`}>
                  <Store className="h-3.5 w-3.5 shrink-0 text-sky-600" />
                  <span className="flex-1 truncate">{s.name}{s.floor ? <span className="text-slate-400"> · {s.floor}</span> : null}</span>
                  <span className="text-[11px] text-slate-400">{s.location_name}</span>
                </button>
              ))}
          </div>
        </div>
      )}
      {error && <p className="text-xs font-semibold text-rose-600" data-testid="review-store-error">Mağaza seçmeden onaylanamaz.</p>}
      <p className="text-xs text-slate-500">Onaylanınca başvuru bilgileri, belgeler ve kullanıcı hesabı seçilen mağazaya taşınır; firma Mağazalar menüsünde görünür.</p>
    </div>
  );
};
